// Utility function to sort items by order
export function sortItemsByOrder<T extends { id: string }>(items: T[], order?: string[]): T[] {
  if (!items?.length || !order?.length) return items;

  const orderMap = new Map();
  order.forEach((id, index) => {
    orderMap.set(id, index);
  });

  return [...items].sort((a, b) => {
    const orderA = orderMap.has(a.id) ? orderMap.get(a.id) : Number.MAX_SAFE_INTEGER;
    const orderB = orderMap.has(b.id) ? orderMap.get(b.id) : Number.MAX_SAFE_INTEGER;
    return orderA - orderB;
  });
}
